const DEBUG_STORAGE_KEY = 'STARTAX_DEBUG_REWARDS';

function isBrowserDebugEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search || '');
    return (
      params.get('debugRewards') === '1' ||
      params.get('startaxDebug') === '1' ||
      window.localStorage?.getItem(DEBUG_STORAGE_KEY) === '1'
    );
  } catch (error) {
    return false;
  }
}

export function logRewardDebug(eventName, payload = {}) {
  if (!isBrowserDebugEnabled()) return;
  const stamp = new Date().toISOString().slice(11, 23);
  // Keep this as a compact console log, not a UI mutation. It is meant for
  // debugging current-receiver/reward/reveal timing without changing gameplay.
  // Enable with: localStorage.STARTAX_DEBUG_REWARDS = '1'
  // Disable with: localStorage.removeItem('STARTAX_DEBUG_REWARDS')
  console.info(`[StarTax reward:${eventName}] ${stamp}`, payload);
}
